import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  font-family: OpenSans;\n  font-size: 13px;\n  line-height: 1.5;\n  position: relative;\n  min-width: 156px;\n  vertical-align: top;\n\n  * {\n    outline: 0;\n  }\n\n  .DayPicker-Caption {\n    display: table-caption;\n    margin: 0 -8px;\n  }\n\n  .DayPicker-Months {\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .DayPicker-Month {\n    display: inline-table;\n    margin: 0 8px 8px;\n    border-collapse: collapse;\n    border-spacing: 0;\n    user-select: none;\n  }\n\n  .DayPicker-Weekdays {\n    display: table-header-group;\n  }\n\n  .DayPicker-WeekdaysRow {\n    display: table-row;\n  }\n\n  .DayPicker-Weekday {\n    display: table-cell;\n    width: 30px;\n    height: 30px;\n    vertical-align: middle;\n    text-align: center;\n    font-weight: 600;\n    padding-top: 8px;\n\n    abbr[title] {\n      text-decoration: none;\n    }\n  }\n\n  .DayPicker-Body {\n    display: table-row-group;\n  }\n\n  .DayPicker-Week {\n    display: table-row;\n  }\n\n  .DayPicker-Day,\n  .DayPicker-WeekNumber {\n    display: table-cell;\n    width: 30px;\n    height: 30px;\n    vertical-align: middle;\n    text-align: center;\n    line-height: 1.5;\n  }\n\n  .DayPicker-Day {\n    border-radius: 5px;\n    cursor: pointer;\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      color: ", ";\n      background-color: ", ";\n    }\n\n    &:active {\n      color: ", ";\n      background-color: ", ";\n    }\n\n    &.DayPicker-Day--disabled,\n    &.DayPicker-Day--outside {\n      color: ", " !important;\n      background-color: ", " !important;\n    }\n\n    &.DayPicker-Day--selected {\n      border-radius: 5px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    &.DayPicker-Day--selected-range,\n    &.DayPicker-Day--hovered-range {\n      border-radius: 0;\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  margin: 0 28px;\n  min-height: 36px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 0;\n\n  &:hover,\n  &:focus {\n    border: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  padding: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback } from 'react';
import DayPicker from 'react-day-picker';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Button } from '../button/Button';
import { Select } from '../select/Select';
import { Icon } from '../icon/Icon';
import * as DateUtils from './dateUtils';
import * as DateFns from 'date-fns/fp';
var Navbar = styled.div(_templateObject());
var StyledNavBarButton = styled(Button)(_templateObject2());
var StyledSelect = styled(Select)(_templateObject3(), themeGet('colors.transparent'));
var CaptionContainer = styled.div(_templateObject4());
var StyledDayPicker = styled(DayPicker)(_templateObject5(), themeGet('calendar.day.color'), themeGet('calendar.day.hover.color'), themeGet('calendar.day.hover.backgroundColor'), themeGet('calendar.day.active.color'), themeGet('calendar.day.active.backgroundColor'), themeGet('calendar.day.disabled.color'), themeGet('calendar.day.disabled.backgroundColor'), themeGet('calendar.day.selected.color'), themeGet('calendar.day.selected.backgroundColor'), themeGet('calendar.day.selected.hover.backgroundColor'), themeGet('calendar.day.selected.range.color'), themeGet('calendar.day.selected.range.backgroundColor'));
var Divider = styled.div(_templateObject6(), themeGet('calendar.separator.border'));

var DatePickerCaption = function DatePickerCaption(_ref) {
  var classNames = _ref.classNames,
      date = _ref.date,
      onChange = _ref.onChange,
      locale = _ref.locale,
      localeUtils = _ref.localeUtils,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      _ref$months = _ref.months,
      months = _ref$months === void 0 ? localeUtils.getMonths(locale) : _ref$months;
  var minYear = minDate.getFullYear();
  var maxYear = maxDate.getFullYear();
  var displayMonth = date.getMonth();
  var displayYear = date.getFullYear(); // build the list of available months, limiting based on minDate and maxDate as necessary

  var startMonth = displayYear === minYear ? minDate.getMonth() : 0;
  var endMonth = displayYear === maxYear ? maxDate.getMonth() + 1 : undefined;
  var monthOptions = months.map(function (month, i) {
    return {
      name: month,
      value: i
    };
  }).slice(startMonth, endMonth);
  var yearOptions = DateUtils.getYearsBetween([minYear, maxYear]).map(function (year) {
    return {
      name: year,
      value: year
    };
  });
  var handleMonthChange = useCallback(function (_ref2) {
    var value = _ref2.value;
    var newDate = DateUtils.clone(date);
    newDate.setMonth(value);
    onChange && onChange({
      target: {
        value: newDate
      }
    });
  }, [date, onChange]);
  var handleYearChange = useCallback(function (_ref3) {
    var value = _ref3.value;
    var newDate = DateUtils.clone(date);
    newDate.setFullYear(value);
    onChange && onChange({
      target: {
        value: newDate
      }
    });
  }, [date, onChange]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: classNames.caption
    },
    /*#__PURE__*/
    React.createElement(CaptionContainer, null,
    /*#__PURE__*/
    React.createElement(StyledSelect, {
      width: "124px",
      onChange: handleYearChange,
      value: yearOptions.find(function (_ref4) {
        var value = _ref4.value;
        return value === displayYear;
      }),
      options: yearOptions,
      placeholder: "Year"
    }),
    /*#__PURE__*/
    React.createElement(StyledSelect, {
      onChange: handleMonthChange,
      value: monthOptions.find(function (_ref5) {
        var value = _ref5.value;
        return value === displayMonth;
      }),
      options: monthOptions,
      placeholder: "Month"
    })),
    /*#__PURE__*/
    React.createElement(Divider, null))
  );
};

var DatePickerNavbar = function DatePickerNavbar(_ref6) {
  var classNames = _ref6.classNames,
      month = _ref6.month,
      maxDate = _ref6.maxDate,
      minDate = _ref6.minDate,
      onNextClick = _ref6.onNextClick,
      onPreviousClick = _ref6.onPreviousClick;
  return (
    /*#__PURE__*/
    React.createElement(Navbar, {
      className: classNames.navBar
    },
    /*#__PURE__*/
    React.createElement(StyledNavBarButton, {
      type: "button",
      variant: "link",
      size: "small",
      disabled: DateFns.isSameMonth(month, minDate),
      onClick: useCallback(function () {
        return onPreviousClick();
      }, [onPreviousClick])
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "ARROW_LEFT",
      fontSize: 20,
      color: "blacks.7"
    })),
    /*#__PURE__*/
    React.createElement(StyledNavBarButton, {
      type: "button",
      variant: "link",
      size: "small",
      disabled: DateFns.isSameMonth(month, maxDate),
      onClick: useCallback(function () {
        return onNextClick();
      }, [onNextClick])
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "ARROW_RIGHT",
      fontSize: 20,
      color: "blacks.7"
    })))
  );
};

var EnhancedDayPicker = function EnhancedDayPicker(_ref7) {
  var onChange = _ref7.onChange,
      restProps = _objectWithoutProperties(_ref7, ["onChange"]);

  var fromMonth = restProps.fromMonth,
      toMonth = restProps.toMonth;
  var renderCaption = useCallback(function (props) {
    return (
      /*#__PURE__*/
      React.createElement(DatePickerCaption, _extends({}, props, {
        onChange: onChange,
        maxDate: toMonth,
        minDate: fromMonth
      }))
    );
  }, [onChange, fromMonth, toMonth]);
  var renderNavbar = useCallback(function (props) {
    return (
      /*#__PURE__*/
      React.createElement(DatePickerNavbar, _extends({}, props, {
        maxDate: toMonth,
        minDate: fromMonth
      }))
    );
  }, [toMonth, fromMonth]);
  return (
    /*#__PURE__*/
    React.createElement(StyledDayPicker, _extends({
      captionElement: renderCaption,
      navbarElement: renderNavbar
    }, restProps))
  );
};

export default EnhancedDayPicker;